import { render, staticRenderFns } from "./CompanyReleases.vue?vue&type=template&id=4db01770&scoped=true"
import script from "./CompanyReleases.vue?vue&type=script&lang=js"
export * from "./CompanyReleases.vue?vue&type=script&lang=js"
import style0 from "./CompanyReleases.vue?vue&type=style&index=0&id=4db01770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db01770",
  null
  
)

export default component.exports